import React from 'react';
import { Navigate } from 'react-router-dom';
import useConnectVm from '|/app/purchase/flow/connect/use-connect-vm';
import ConnectLoading from './connect-loading';

const Connect = () => {
  const newRoute = useConnectVm();

  return newRoute === null ? <ConnectLoading /> : <Navigate to={newRoute} replace={true} />;
};

export default Connect;
